import React from 'react';

import { useRouter } from 'next/router';
import styled from 'styled-components';

import { desktop } from '../../styles';
import MemberSignInLinkButton from '../MemberSignInLinkButton/MemberSignInLinkButton';

const StyledMemberSignInLinkButton = styled(MemberSignInLinkButton)`
  margin-left: auto;
  align-self: center;
`;

const Container = styled.div`
  display: grid;
  place-items: center;
  height: 48px;
  grid-template-columns: auto 1fr;

  ${desktop`
    flex-basis: 72px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding-right: 40px;
  `}

  background-color: ${({ theme }) => theme.colors.white};

  border-bottom: 1px solid ${({ theme }) => theme.colors.marble};
  padding: 8px 16px;
`;

const HeaderLogo = styled.img.attrs({
  src: '/static/images/membership_modal/header-logo.svg',
  alt: 'Savage X Fenty',
})`
  display: none;

  ${desktop`
    display: block;
  `}
`;

const BackButtonContainer = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: start;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray250};
  }
`;

const BackButton = styled.img.attrs({
  src: '/static/images/membership_modal/back-button.svg',
})``;

interface HeaderProps {
  onCancel: () => void;
  isLoggedIn: boolean;
}

export const Header = ({ onCancel, isLoggedIn }: HeaderProps) => {
  const router = useRouter();

  const navigateToPage = () => {
    router.push('/checkout/sign-up');
  };

  return (
    <Container>
      <BackButtonContainer onClick={onCancel}>
        <BackButton />
      </BackButtonContainer>
      <HeaderLogo />
      {!isLoggedIn && <StyledMemberSignInLinkButton onClick={navigateToPage} />}
    </Container>
  );
};
